import { BaseDateExpression } from "./BaseDateExpression";
import { ExpressionValue } from "../../ExpressionValue";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import { DateDataDefinition } from "../../../Common/Data/Definitions/DateDataDefinition";

export enum DateSpanType {
    SECONDS = "seconds",
    MINUTES = "minutes",
    DAYS = "days",
    BUSINESS_DAYS = "business days",
    WEEKS = "weeks",
    MONTHS = "months",
    YEARS = "years",
}

export abstract class BaseDateCalculateExpression extends BaseDateExpression {
    adjustBy: ExpressionValue;
    baseDate: ExpressionValue;
    calculateType: DateSpanType = DateSpanType.SECONDS;

    constructor() {
        super();
        this.adjustBy = ExpressionValue.createExpressionValue(this, "adjustBy", new NumberDataDefinition());
        this.baseDate = ExpressionValue.createExpressionValue(this, "baseDate", new DateDataDefinition());
    }

    getStorageData(): object {
        let data = super.getStorageData();
        Reflect.set(data, "calculateType", this.calculateType);
        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);
        this.calculateType = Reflect.get(data, "calculateType");
    }
}
